/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Active
 *
 * 2 = Completed
 *
 * 3 = Cancelled
 *
 * 4 = NoShow
 *
 * 5 = Deleted
 */
export enum ServiceBookingStatusEnum {
  Active = 1,
  Completed = 2,
  Cancelled = 3,
  NoShow = 4,
  Deleted = 5,
}
